import { d as r } from "./define-element-Dl91r6Vu.js";
import { Overlay as o } from "./Overlay-DDWP3X23.js";
r("sp-overlay", o);
//# sourceMappingURL=sp-overlay-C7imRS_0.js.map
